// extracted by mini-css-extract-plugin
export default {"bluewaveBlue":"#377bde","spruceBlue":"#24637d","spruceOrange":"#f69546","spruceRed":"#e72e28","modifierLowPercent":"8.75%","modifierMediumPercent":"55%"};